import kr from '../kr/kr';
import HTMLClass from '../kr/utils/HTMLClass';

export default class OpenControllsMenu extends kr.Component {
    init() {
        this.openContolls();
    }
    openContolls() {

        const currencyMenu = document.querySelector('.header__hidden.currency');
        const languageMenu = document.querySelector('.header__hidden.language');
        const closeButtons = document.querySelectorAll('.header__hidden__close')

        this.on('click', '.current-currency', (target, event) => {
            event.preventDefault();
            HTMLClass.toggleClass(currencyMenu, 'header__hidden--opened')

            if (languageMenu.classList.contains('header__hidden--opened')) languageMenu.classList.remove('header__hidden--opened')
        });

        this.on('click', '.current-language', (target, event) => {
            event.preventDefault();
            HTMLClass.toggleClass(languageMenu, 'header__hidden--opened')

            if (currencyMenu.classList.contains('header__hidden--opened')) currencyMenu.classList.remove('header__hidden--opened')
        });

        for (let button of closeButtons) {
            this.on('click', button, (target, event) => {
                event.preventDefault();
                if (currencyMenu.classList.contains('header__hidden--opened')) {
                    currencyMenu.classList.remove('header__hidden--opened')
                }
                
                else if (languageMenu.classList.contains('header__hidden--opened')) {
                    languageMenu.classList.remove('header__hidden--opened')
                }
            });
            
        }
    }
}

kr.registerComponent('.topbar__case', {
    component: OpenControllsMenu
});